import React, { useEffect, useState } from "react";
import {
    createCounter,
    updateCounter,
    getCounter,
    getCounters,
    destroyCounter,
} from "../../../../_api/Counter";
import { useNavigate, useParams } from "react-router-dom";
import { InputForm } from "../../../../_helpers/components/Forms/InputLabel";
import { Button } from "../../../../_helpers/components/Button";
import toast from "react-hot-toast";
import { Loader } from "../../../../_helpers/components/Forms/Loader";
import { DefaultDropdown } from "../../../../_helpers/components/Forms/Dropdown";
import { Toggle } from "../../../../_helpers/components/Forms/ToggleButton";
import { getHourTypes } from "../../../../_api/HourType";
import { BackButton } from "../../../../_helpers/components/BackButton";

const AddCounter = () => {
    const navigate = useNavigate();
    const { counter_id } = useParams();
    const [name, setName] = useState("");
    const [type, setType] = useState("HOURS");
    const [dateAcquisition, setDateAcquisition] = useState(
        new Date().toISOString().split("T")[0]
    );
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    const [counters, setCounters] = useState([]);
    const [counter, setCounter] = useState(null);

    const [hoursType, setHoursType] = useState([]);

    const [acquisitions, setAcquisitions] = useState([
        {
            gain: 0,
            frequence_number: 0,
            frequence_periode: "DAY",
            hourType: null,
            operation_type: "ACQUIS_PLANNING",
            rate: 100,
            top_limit: 0,
            low_limit: 0,
            counter_id_bascule: "",
            order: 0,
            limits_enabled: false,
        },
    ]);

    const handleChange = (index, field, value) => {
        const newList = [...acquisitions];
        newList[index][field] = value;
        setAcquisitions(newList);
    };

    const moveRule = (index, direction) => {
        setAcquisitions((old) => {
            const nextIndex = index + direction;
            if (nextIndex < 0 || nextIndex >= old.length) return old;

            const next = [...old];
            const [moved] = next.splice(index, 1);
            next.splice(nextIndex, 0, moved);

            return next.map((item, idx) => ({ ...item, order: idx }));
        });
    };

    const addLine = () => {
        setAcquisitions([
            ...acquisitions,
            {
                gain: 0,
                frequence_number: 0,
                frequence_periode: "DAY",
                hourType: (hoursType.length > 0
                    ? hoursType[0].value
                    : null),
                operation_type: "ACQUIS_PLANNING",
                rate: 100,
                top_limit: 0,
                low_limit: 0,
                counter_id_bascule: "",
                order: 0,
                limits_enabled: false,
            },
        ]);
    };

    const loadCounter = async () => {
        setIsLoading(true);
        if (counter_id) {
            await getCounter(counter_id)
                .then((resp) => {
                    const data = resp.data;
                    setName(data.name);
                    setType(data.type);
                    setDateAcquisition(data.date_acquisition);
                    setAcquisitions(
                        [...data.rules]
                            .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
                            .map((rule) => {
                                return {
                                    gain: rule.frequence_acquisition,
                                    frequence_number: rule.frequence_number,
                                    frequence_periode: rule.frequence_period,
                                    hourType: rule.hour_type,
                                    operation_type: rule.operation_type,
                                    rate: rule.rate,
                                    counter_id_bascule: rule.counter_id_bascule,
                                    top_limit: rule.top_limit,
                                    low_limit: rule.low_limit,
                                    limits_enabled: rule.low_limit !== null || rule.top_limit !== null,
                                    order: rule.order,
                                };
                            })
                    );
                })
                .catch(() => {
                    navigate("/company/counters");
                });
        }
        setIsLoading(false);
    };

    useEffect(() => {
        loadCounter();
        getCounters().then((resp) => {
            const countersOptions = resp.data.map((counter) => ({
                value: counter.id,
                label: counter.name,
            }));
            setCounters(countersOptions);
            let test = acquisitions.map((item) => ({
                ...item,
                counter:
                    item.counter ??
                    (countersOptions.length > 0
                        ? countersOptions[0].value
                        : null),
            }));
            if (!counter_id) {
                setAcquisitions(test);
            }
        });

        getHourTypes().then((resp) => {
            const hourTypesOptions = resp.data.map((ht) => ({
                value: ht.id,
                label: ht.name,
            }));
            setHoursType(hourTypesOptions);
            if (!counter_id) {
                setAcquisitions((old) =>
                    old.map((item) => ({
                        ...item,
                        hourType:
                            item.hourType ??
                            (hourTypesOptions.length > 0
                                ? hourTypesOptions[0].value
                                : null),
                    }))
                );
            }
        });

    }, [counter_id]);

    const addCounter = () => {

        acquisitions.forEach((item, idx) => {
            if (!item.limits_enabled) {
                item.low_limit = null;
                item.top_limit = null;
            }
            item.order = idx;
        });

        const payload = {
            name,
            type,
            acquisitions,
            date_acquisition: dateAcquisition,
            counter: counter,
        };

        setIsSaving(true);
        if (counter_id) {
            updateCounter(counter_id, payload).then(() => {
                toast("Modification enregistrée.");
                navigate("/company/counters");
            }).finally(() => {
                setIsSaving(false);
            });
        } else {
            createCounter(payload)
                .then(() => {
                    toast(`Le compteur "${payload.name}" a été créé.`);
                    navigate("/company/counters");
                })
                .catch(() => {
                    toast("Erreur lors de la création du compteur.");
                })
                .finally(() => {
                    setIsSaving(false);
                });
        }
    };

    const deleteCounter = () => {
        if (counter_id) {
            setIsDeleting(true);
            destroyCounter(counter_id).then(() => {
                toast(`Le compteur "${name}" a été supprimé.`);
                navigate("/company/counters");
            }).finally(() => {
                setIsDeleting(false);
            });
        } else {
            navigate("/company/counters");
        }
    };

    const TypeLabel =
        {
            HOURS: "Heures",
            DAYS: "Jours",
        }[type] || type.toLowerCase();

    const removeLine = (index) => {
        const newList = [...acquisitions];
        newList.splice(index, 1);
        setAcquisitions(newList);
    };

    const listOperations = () => {
        return [
            {
                label: "Acquisition planning",
                value: "ACQUIS_PLANNING",
            },
            {
                label: "Consommation planning",
                value: "CONSOMMATION_PLANNING",
            },
            {
                label: "Alimentation automatique",
                value: "AUTO_ALIM",
            },
            {
                label: "Perdre les " + TypeLabel,
                value: "LOST",
            },
            {
                label: "Cumuler les " + TypeLabel,
                value: "RESCHEDULE",
            },
            {
                label: "Basculer vers un compteur",
                value: "TOPPLE",
            },
            {
                label: "Ecart théorique / réalisé",
                value: "ECART_THEORICAL",
            },
            {
                label: "Ecart prévisionnel / réalisé",
                value: "ECART_PROVISIONAL",
            },
        ]
    }

    const operationWithHourType = [
        "ACQUIS_PLANNING",
        "CONSOMMATION_PLANNING",
    ];
    const operationWithLimits = [
        "RESCHEDULE",
        "TOPPLE",
        "ECART_THEORICAL",
        "ECART_PROVISIONAL",
    ];
    const operationWithFrequency = [
        "AUTO_ALIM",
        "LOST",
        "RESCHEDULE",
        "TOPPLE",
    ];
    const operationWithFrequencyDayOrWeek = [
        "ACQUIS_PLANNING",
        "CONSOMMATION_PLANNING",
        "ECART_THEORICAL",
        "ECART_PROVISIONAL",
    ];
    const operationWithRate = [
        "ACQUIS_PLANNING",
        "CONSOMMATION_PLANNING",
        "ECART_THEORICAL",
        "ECART_PROVISIONAL",
    ];

    return (
        <div className="min-h-full bg-gray-50">
            {/* Header */}
            <div className="bg-white border-b border-gray-200 shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="flex items-center justify-between flex-wrap gap-4">
                        <div className="flex items-center space-x-4">
                            <BackButton
                                onClick={() => navigate("/company/counters")}
                                title="Retour"
                            />

                            <div>
                                <h1 className="text-3xl font-bold text-gray-900">
                                    {counter_id ? "Modifier" : "Ajouter"} un compteur
                                </h1>
                                <p className="mt-2 text-sm text-gray-600">
                                    {counter_id ? "Modifiez" : "Créez"} un compteur pour gérer les heures ou jours
                                </p>
                            </div>
                        </div>
                        <div className="flex flex-wrap gap-2">
                            {counter_id && (
                                <Button
                                    action={deleteCounter}
                                    type="red"
                                    name="Supprimer"
                                    loading={isDeleting}
                                />
                            )}
                            <Button
                                action={addCounter}
                                name={counter_id ? "Valider" : "Ajouter"}
                                loading={isSaving}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Contenu principal */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                {isLoading ? (
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                        <div className="flex items-center justify-center py-12">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-app-primary"></div>
                        </div>
                    </div>
                ) : (
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                        <div className="flex flex-wrap -mx-2">
                            <div className="w-full md:w-1/2 px-2">
                                <h4 className="text-left block uppercase tracking-wide text-app-primary text-sm font-bold mb-2">
                                    Informations du compteur
                                </h4>
                                <div className="flex flex-wrap -mx-2">
                                    <div className="w-full px-2">
                                        <InputForm
                                            name="Nom"
                                            value={name}
                                            set={setName}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="flex flex-wrap -mx-2">
                                    <div className="w-full md:w-1/2 px-2">
                                        <InputForm
                                            name="Départ de l'acquisition"
                                            value={dateAcquisition}
                                            set={setDateAcquisition}
                                            type="date"
                                            required
                                        />
                                    </div>
                                    <div className="w-full md:w-1/2 px-2">
                                        <DefaultDropdown
                                            name="Compteur en heures/jours ?"
                                            required={true}
                                            options={[
                                                { label: "Heures", value: "HOURS" },
                                                { label: "Jours", value: "DAYS" },
                                            ]}
                                            value={type}
                                            onChange={(e) => setType(e.target.value)}
                                            className="w-full md:w-lg"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr />

                        <div className="flex justify-between">
                            <div>
                                <h4 className="text-left block uppercase tracking-wide text-app-primary text-sm font-bold mb-2">
                                    Règles de calcul
                                </h4>
                            </div>
                            <Button
                                action={addLine}
                                type="empty"
                                name="+ Ajouter une règle"
                            />
                        </div>

                        <hr />

                        {acquisitions.map((item, index) => {
                            return (
                                <div
                                    key={index}
                                    className="flex flex-wrap -mx-2 mb-3 border-b pb-2 content-end"
                                >
                                    <div className="px-2 mb-2 w-5/6 h-16 content-end">
                                        <DefaultDropdown
                                            name="Type de règle"
                                            required={true}
                                            options={listOperations()}
                                            value={item.operation_type}
                                            onChange={(e) =>
                                                handleChange(
                                                    index,
                                                    "operation_type",
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </div>
                                    <div className="px-2 mb-2 w-1/6 h-16 content-end">
                                        <div className="flex items-end justify-end gap-1">
                                            <button
                                                type="button"
                                                className="h-9 w-9 rounded-md border border-gray-200 bg-white text-gray-500 hover:border-gray-300 hover:text-gray-700 disabled:opacity-40 disabled:cursor-not-allowed"
                                                onClick={() => moveRule(index, -1)}
                                                disabled={index === 0}
                                                title="Monter la règle"
                                                aria-label="Monter la règle"
                                            >
                                                ↑
                                            </button>
                                            <button
                                                type="button"
                                                className="h-9 w-9 rounded-md border border-gray-200 bg-white text-gray-500 hover:border-gray-300 hover:text-gray-700 disabled:opacity-40 disabled:cursor-not-allowed"
                                                onClick={() => moveRule(index, 1)}
                                                disabled={index === acquisitions.length - 1}
                                                title="Descendre la règle"
                                                aria-label="Descendre la règle"
                                            >
                                                ↓
                                            </button>

                                            <Button
                                                action={() => removeLine(index)}
                                                type="custom"
                                                title="Supprimer"
                                                customCN="inline-flex items-center justify-center rounded-md border border-transparent p-2 text-red-700 hover:bg-red-50 hover:text-red-800 focus:outline-hidden focus:shadow-outline"
                                                name={
                                                    <>
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            className="h-5 w-5"
                                                            aria-hidden="true"
                                                        >
                                                            <path d="M3 6h18" />
                                                            <path d="M8 6V4h8v2" />
                                                            <path d="M19 6l-1 14H6L5 6" />
                                                            <path d="M10 11v6" />
                                                            <path d="M14 11v6" />
                                                        </svg>
                                                        <span className="sr-only">Supprimer</span>
                                                    </>
                                                }
                                            />
                                        </div>
                                    </div>
                                    {operationWithHourType.includes(item.operation_type) && (
                                        <div className="w-full md:w-1/6 px-2 mb-2 grow">
                                            <DefaultDropdown
                                                name="Type d'heures rattaché ?"
                                                required={true}
                                                options={hoursType}
                                                value={item.hourType}
                                                onChange={(e) =>
                                                    handleChange(
                                                        index,
                                                        "hourType",
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </div>
                                    )}

                                    {item.operation_type === "TOPPLE" && counters.length > 0 && (
                                        <div className="w-full md:w-1/6 px-2 mb-2 grow">
                                            <DefaultDropdown
                                                name="Compteur de bascule"
                                                required={true}
                                                options={
                                                    counter_id
                                                        ? counters.filter(
                                                            (count) =>
                                                                count.value.toString() !==
                                                                counter_id.toString()
                                                        )
                                                        : counters
                                                }
                                                value={item.counter_id_bascule}
                                                onChange={(e) =>
                                                    handleChange(
                                                        index,
                                                        "counter_id_bascule",
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </div>
                                    )}

                                    {item.operation_type === "AUTO_ALIM" && (
                                        <div className="w-full md:w-1/6 px-2 mb-2 grow">
                                            <InputForm
                                                name={`Acquisition`}
                                                value={item.gain}
                                                set={(val) =>
                                                    handleChange(index, "gain", val)
                                                }
                                                type="number"
                                                required
                                            />
                                        </div>
                                    )}

                                    {operationWithFrequency.includes(item.operation_type) && (
                                        <>
                                            <div className="w-full md:w-1/6 px-2 mb-2 grow">
                                                <InputForm
                                                    name="Fréquence"
                                                    value={item.frequence_number}
                                                    set={(val) =>
                                                        handleChange(
                                                            index,
                                                            "frequence_number",
                                                            val
                                                        )
                                                    }
                                                    type="number"
                                                    required
                                                />
                                            </div>
                                            <div className="w-full md:w-1/6 px-2 mb-2 grow">
                                                <DefaultDropdown
                                                    name="Période"
                                                    required={true}
                                                    options={[
                                                        {
                                                            label: "Jour",
                                                            value: "DAY",
                                                        },
                                                        {
                                                            label: "Semaine",
                                                            value: "WEEK",
                                                        },
                                                        {
                                                            label: "Mois",
                                                            value: "MONTH",
                                                        },
                                                        {
                                                            label: "Trimestre",
                                                            value: "TRIMESTRE",
                                                        },
                                                        {
                                                            label: "Trimestre 1 (Fin le 31/03)",
                                                            value: "T1",
                                                        },
                                                        {
                                                            label: "Trimestre 2 (Fin le 30/06)",
                                                            value: "T2",
                                                        },
                                                        {
                                                            label: "Trimestre 3 (Fin le 30/09)",
                                                            value: "T3",
                                                        },
                                                        {
                                                            label: "Trimestre 4 (Fin le 31/12)",
                                                            value: "T4",
                                                        },
                                                        {
                                                            label: "Annuel",
                                                            value: "ANNUAL",
                                                        },
                                                    ]}
                                                    value={item.frequence_periode}
                                                    onChange={(e) =>
                                                        handleChange(
                                                            index,
                                                            "frequence_periode",
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </>
                                    )}

                                    {operationWithFrequencyDayOrWeek.includes(item.operation_type) && (
                                        <div className="w-full md:w-1/6 px-2 mb-2 grow">
                                            <DefaultDropdown
                                                name="Période"
                                                required={true}
                                                options={[
                                                    {
                                                        label: "Jour",
                                                        value: "DAY",
                                                    },
                                                    {
                                                        label: "Semaine",
                                                        value: "WEEK",
                                                    },
                                                ]}
                                                value={item.frequence_periode}
                                                onChange={(e) =>
                                                    handleChange(
                                                        index,
                                                        "frequence_periode",
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </div>
                                    )}

                                    {operationWithRate.includes(item.operation_type) && (
                                        <div className="w-full md:w-1/6 px-2 mb-2 grow">
                                            <InputForm
                                                name="Taux"
                                                value={item.rate}
                                                set={(val) =>
                                                    handleChange(index, "rate", val)
                                                }
                                                type="number"
                                                required
                                            />
                                        </div>
                                    )}

                                    {operationWithLimits.includes(item.operation_type) && (
                                        <div className="w-full flex px-2 mb-2 grow">
                                            <Toggle
                                                enabled={item.limits_enabled}
                                                setEnabled={(val) =>
                                                    handleChange(
                                                        index,
                                                        "limits_enabled",
                                                        val
                                                    )}
                                                name="Limites"
                                            />
                                            {item.limits_enabled && (
                                                <>
                                                    <div className="w-full md:w-1/5 px-2">
                                                        <InputForm
                                                            name={`basse`}
                                                            value={item.low_limit ?? 0}
                                                            set={(val) =>
                                                                handleChange(
                                                                    index,
                                                                    "low_limit",
                                                                    val
                                                                )
                                                            }
                                                            type="number"
                                                        />
                                                    </div>
                                                    <div className="w-full md:w-1/5 px-2">
                                                        <InputForm
                                                            name={`haute`}
                                                            value={item.top_limit ?? 0}
                                                            set={(val) =>
                                                                handleChange(
                                                                    index,
                                                                    "top_limit",
                                                                    val
                                                                )
                                                            }
                                                            type="number"
                                                        />
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    )}

                                </div>
                            );
                        })}

                    </div>
                )}
            </div>
        </div>
    );
};

export default AddCounter;
